import { Serializable } from '../../../core/models/serializable';
import { PromoEmailTemplateModel } from './promo-email-template-model';

export class PromoEmailAttachmentModel
  implements Serializable<PromoEmailAttachmentModel>
{
  fromObject(object: any): PromoEmailAttachmentModel {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    return {
      promoEmailAttachmentId: this.promoEmailAttachmentId,
      promoEmailTemplateId: this.promoEmailTemplateId,
      filename: this.filename,
      displayName: this.displayName,
      isDeleted: this.isDeleted,
    };
  }

  public promoEmailAttachmentId: number;
  public promoEmailTemplateId: number;
  public filename: string;
  public displayName: string;
  public isDeleted: boolean;

  constructor(filename: string, originalName: string) {
    this.filename = filename;
    this.displayName = originalName;
    this.promoEmailAttachmentId = -1;
  }
}
